import { Typography } from '@prenuvo/halo';

import { ACTIVITY_LOG_ACTION, ActivityLog, REPORT_FINDING_STATUS } from '@/api';

import { RELATED_OBJECT_TYPE } from '../activity-log.constant';
import { AiActivityLog } from '../ai-activity-log.component';
import { ActivityLogUpdate } from './activity-log-update.component';
import { FullObject } from './full-object.component';

export type ActivityLogContentProps = {
  activityLog: ActivityLog;
};

export function ActivityLogContent({ activityLog }: ActivityLogContentProps) {
  const { action, fullObject, objectDiff, relatedObjectType } = activityLog;

  if (
    action === ACTIVITY_LOG_ACTION.READ &&
    relatedObjectType === RELATED_OBJECT_TYPE &&
    fullObject?.userSession
  ) {
    return (
      <Typography
        className="mt-2"
        translationKey="FCT.ACTIVITY_LOGS.USER_ENTRY_MESSAGE"
        variant="paragraph-sm"
      />
    );
  }

  if (
    action === ACTIVITY_LOG_ACTION.CREATE &&
    relatedObjectType === RELATED_OBJECT_TYPE &&
    fullObject?.aiFinding
  ) {
    return <AiActivityLog action={action} fullObject={fullObject} />;
  }

  if (action === ACTIVITY_LOG_ACTION.CREATE && fullObject) {
    return <FullObject action={ACTIVITY_LOG_ACTION.CREATE} fullObject={fullObject} />;
  }

  if (action === ACTIVITY_LOG_ACTION.UPDATE && objectDiff) {
    const status = objectDiff.status?.new;

    if (status === REPORT_FINDING_STATUS.DEPRECATED) {
      return <FullObject action={ACTIVITY_LOG_ACTION.DELETE} fullObject={fullObject} />;
    }

    return <ActivityLogUpdate activityLog={activityLog} />;
  }

  return null;
}
